import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../context/AuthContext';
import { getVehicleSummary } from '../../../api/ownerTelematics';
import LiveMapCard from './LiveMapCard';
import DrivingScoreCard from './DrivingScoreCard';
import CrashProtectionRow from './CrashProtectionRow';
import CrashAlertCard from './CrashAlertCard';
import NoDeviceUpsell from './NoDeviceUpsell';
import ImmobilizerControl from './ImmobilizerControl';

const POLL_MS = 30 * 1000;

export default function VehicleTelematicsPanel({ vehicleId }) {
  const { t } = useTranslation();
  const { token } = useAuth();
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      setSummary(await getVehicleSummary(vehicleId, token));
    } catch (e) {
      // keep last good summary on transient errors
    } finally {
      setLoading(false);
    }
  }, [vehicleId, token]);

  useEffect(() => {
    load();
    const id = setInterval(load, POLL_MS);
    return () => clearInterval(id);
  }, [load]);

  if (loading && !summary) return null;
  if (!summary) return null;

  return (
    <section className="mt-6 space-y-4">
      <h2 className="text-lg font-bold text-gray-900">{t('ownerTelematics.title')}</h2>
      <CrashAlertCard crashes={summary.crashes} />
      {!summary.device ? (
        <NoDeviceUpsell vehicleId={vehicleId} />
      ) : (
        <>
          <LiveMapCard position={summary.position} live={summary.device.live} />
          <DrivingScoreCard score={summary.score} />
          <CrashProtectionRow active={summary.crashProtection?.active} />
          <ImmobilizerControl
            vehicleId={vehicleId}
            state={summary.immobilization?.state || 'active'}
            onChanged={load}
          />
        </>
      )}
    </section>
  );
}
